import React from "react";
import { object, array, func, bool, number, string } from "prop-types";
import { Link } from "@quintype/components";
import cx from "classnames";

import { checkIfActive } from "./utils";

import "./header-menu-column.m.css";

const generateChildItemsDom = (childItems, toggleMenuBar) =>
  childItems.map((childItem, index) => (
    <li styleName="child-menu-list-item" key={index}>
      {childItem.isExternalLink ? (
        <a target="_blank" rel="noopener noreferrer" href={childItem.completeUrl}>
          <span onClick={toggleMenuBar}>{childItem.title}</span>
        </a>
      ) : (
        <Link href={childItem.completeUrl}>
          <span onClick={toggleMenuBar}>{childItem.title}</span>
        </Link>
      )}
    </li>
  ));

const HeaderMenuColumn = ({
  headerMenuColumn,
  childItems,
  toggleMenuBar,
  toggleMenuItem,
  menuItemIndex,
  showDropDown,
  currentPath
}) => {
  const childItemsDom = generateChildItemsDom(childItems, toggleMenuBar);
  const isDropdownShown = showDropDown ? "list-show" : "list-hide";
  const activeStyle = cx("single-item", {
    active: checkIfActive(currentPath, headerMenuColumn.completeUrl)
  });

  return childItemsDom.length ? (
    <ul styleName={`list ${isDropdownShown}`} onClick={() => toggleMenuItem(menuItemIndex)}>
      {headerMenuColumn.title && (
        <li styleName={activeStyle}>
          {headerMenuColumn.isExternalLink ? (
            <a target="_blank" rel="noopener noreferrer" href={headerMenuColumn.completeUrl || "#"}>
              <span onClick={toggleMenuBar}>{headerMenuColumn.title}</span>
            </a>
          ) : (
            <Link href={headerMenuColumn.completeUrl || "#"}>
              <span onClick={toggleMenuBar}>{headerMenuColumn.title}</span>
            </Link>
          )}
        </li>
      )}
      {showDropDown && <ul styleName="child-menu-list mobile">{childItemsDom}</ul>}
      {childItemsDom && <ul styleName="child-menu-list desktop">{childItemsDom}</ul>}
    </ul>
  ) : (
    headerMenuColumn.title && (
      <li styleName={activeStyle}>
        {headerMenuColumn.isExternalLink ? (
          <a target="_blank" rel="noopener noreferrer" href={headerMenuColumn.completeUrl || "#"}>
            <span onClick={toggleMenuBar}>{headerMenuColumn.title}</span>
          </a>
        ) : (
          <Link href={headerMenuColumn.completeUrl || "#"}>
            <span onClick={toggleMenuBar}>{headerMenuColumn.title}</span>
          </Link>
        )}
      </li>
    )
  );
};

export default HeaderMenuColumn;

HeaderMenuColumn.propTypes = {
  headerMenuColumn: object,
  childItems: array,
  toggleMenuBar: func,
  toggleMenuItem: func,
  showDropDown: bool,
  menuItemIndex: number,
  currentPath: string
};
